import React, { Component } from 'react'
import Img from 'gatsby-image'

import './card.css'

class Card extends Component {

  render () {
    let data = this.props.data;
    let img = <Img className="card-img" fluid = {this.props.fluid}></Img>
    let cardImg = data.isClickable ? <a target="_blank" href={this.props.link ? this.props.link : data.href}>{img}</a> : <div>{img}</div>;
    return (
      <div className="card">
        {cardImg}
        <div className="card-content">
          <div className="card-name">
            {data.name}
          </div>
          <div className="card-info">
            <div className="card-info-block">
              <div style={{lineHeight: 1.5}}>
                {data.position}
              </div>
            </div>
            <div className="card-info-block">
              <div style={{lineHeight: 1.5}}>
                {data.affiliation}
              </div>
            </div>
            <div className="card-info-block">
              <div style={{lineHeight: 1.5}}>
                {data.affiliate_position}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default Card
